import React, { useCallback } from 'react';
import DefaultToolTipHeader from './ToolTipComponents/DefaultToolTipHeader';
import DefaultToolTipBody from './ToolTipComponents/DefaultToolTipBody';
import SingleButtonRow from './ToolTipComponents/SingleButtonRow';
import DefaultButtonRow, {
  WorkflowStepActionButtonProps,
} from './ToolTipComponents/DefaultButtonRow';
import { DefaultWorkflowStepToolTipProps } from '../types';

const WorkflowStepToolTip: React.FC<DefaultWorkflowStepToolTipProps> = props => {
  const { workflowState, moveNextStep, toggleCompleted } = props.workflowHook;
  const { currentStep, activeStepId } = workflowState;

  const toggleComplete = useCallback(() => {
    toggleCompleted(currentStep.id);
  }, [currentStep, toggleCompleted]);

  if (!currentStep) return <div>No active step</div>; // not supposed to happen

  if (activeStepId === 'root') {
    const actionButtonProps: WorkflowStepActionButtonProps = {
      completedText: 'Redo Workflow',
      startedText: 'Complete Workflow',
      startedStateClick: toggleComplete,
      allChildrenCompletedText: 'Complete Workflow',
      allChildrenCompletedStateClick: toggleComplete,
      uncompletedText: 'Start Workflow',
      uncompletedStateClick: moveNextStep,
    };

    return (
      <div>
        <DefaultToolTipHeader workflowHook={props.workflowHook} />
        <DefaultToolTipBody workflowHook={props.workflowHook} />
        <SingleButtonRow workflowHook={props.workflowHook} actionButtonProps={actionButtonProps} />
      </div>
    );
  }

  return (
    <div>
      <DefaultToolTipHeader workflowHook={props.workflowHook} />
      <DefaultToolTipBody workflowHook={props.workflowHook} />
      <DefaultButtonRow workflowHook={props.workflowHook} />
    </div>
  );
};

export default React.memo(WorkflowStepToolTip);
